/* Phone 2FA verify modal (Phase 1). Reusable global: window.MHVVerify.
   - open({ onVerified, message }) — show the modal, text a code, collect + confirm.
   - ensureVerified({ onVerified, message }) — check status; if the (new) account must
     verify, open the modal; otherwise run onVerified immediately.
   Uses window.mhvFetch (auto-attaches X-Customer-Key). Self-contained DOM + styles. */
(function () {
  'use strict';
  var SERVER = (window.MHV && window.MHV.SERVER_URL) || 'https://mhv-viewer-app-1df0c0c61ed9.herokuapp.com';
  var els = null, cb = null, sending = false;

  function api(path, body) {
    return window.mhvFetch(SERVER + path, {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body || {})
    }).then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, data: d }; }); });
  }

  function ensureDom() {
    if (els) return;
    var ov = document.createElement('div');
    ov.id = 'mhv-verify-overlay';
    ov.innerHTML =
      '<div class="mhv-verify-card" role="dialog" aria-modal="true" aria-labelledby="mhv-verify-title">' +
        '<button type="button" class="mhv-verify-close" aria-label="Close">&times;</button>' +
        '<div class="mhv-verify-ico">🔒</div>' +
        '<h2 class="mhv-verify-title" id="mhv-verify-title">Verify your phone</h2>' +
        '<p class="mhv-verify-sub" id="mhv-verify-sub"></p>' +
        '<div class="mhv-verify-err" id="mhv-verify-err" style="display:none"></div>' +
        '<button type="button" class="mhv-verify-btn mhv-verify-send" id="mhv-verify-send">Text me a code</button>' +
        '<div class="mhv-verify-code-row" id="mhv-verify-code-row" style="display:none">' +
          '<input type="text" inputmode="numeric" maxlength="6" id="mhv-verify-code" placeholder="000000" autocomplete="one-time-code">' +
          '<button type="button" class="mhv-verify-btn mhv-verify-confirm" id="mhv-verify-confirm">Verify</button>' +
        '</div>' +
        '<button type="button" class="mhv-verify-resend" id="mhv-verify-resend" style="display:none">Resend code</button>' +
      '</div>';
    document.body.appendChild(ov);
    var $ = function (id) { return ov.querySelector(id); };
    els = {
      ov: ov, sub: $('#mhv-verify-sub'), err: $('#mhv-verify-err'),
      send: $('#mhv-verify-send'), codeRow: $('#mhv-verify-code-row'),
      code: $('#mhv-verify-code'), confirm: $('#mhv-verify-confirm'), resend: $('#mhv-verify-resend')
    };
    ov.querySelector('.mhv-verify-close').addEventListener('click', close);
    ov.addEventListener('click', function (e) { if (e.target === ov) close(); });
    els.send.addEventListener('click', sendCode);
    els.resend.addEventListener('click', sendCode);
    els.confirm.addEventListener('click', confirmCode);
    els.code.addEventListener('keydown', function (e) { if (e.key === 'Enter') confirmCode(); });
    els.code.addEventListener('input', function () { els.code.value = els.code.value.replace(/\D/g, ''); });
    var st = document.createElement('style'); st.textContent = CSS; document.head.appendChild(st);
  }

  function showErr(m) { els.err.textContent = m || ''; els.err.style.display = m ? 'block' : 'none'; }

  function sendCode() {
    if (sending) return; sending = true; showErr('');
    els.send.disabled = true; els.resend.disabled = true;
    var orig = els.send.style.display === 'none' ? els.resend : els.send;
    orig.textContent = 'Sending…';
    api('/verify/phone/send', {}).then(function (r) {
      sending = false; els.send.disabled = false; els.resend.disabled = false;
      if (r.data && r.data.alreadyVerified) { onSuccess(); return; }
      if (!r.ok) { els.send.textContent = 'Text me a code'; els.resend.textContent = 'Resend code'; showErr((r.data && r.data.error) || 'Could not send the code.'); return; }
      showCodeStep(r.data.phoneMasked);
    }).catch(function () { sending = false; els.send.disabled = false; els.send.textContent = 'Text me a code'; showErr('Network error — try again.'); });
  }

  function confirmCode() {
    var code = (els.code.value || '').replace(/\D/g, '');
    if (code.length !== 6) { showErr('Enter the 6-digit code.'); return; }
    showErr(''); els.confirm.disabled = true; els.confirm.textContent = 'Verifying…';
    api('/verify/phone/confirm', { code: code }).then(function (r) {
      els.confirm.disabled = false; els.confirm.textContent = 'Verify';
      if (r.ok && r.data && r.data.verified) { onSuccess(); return; }
      showErr((r.data && r.data.error) || 'Verification failed.');
    }).catch(function () { els.confirm.disabled = false; els.confirm.textContent = 'Verify'; showErr('Network error — try again.'); });
  }

  function onSuccess() { var fn = cb; close(); try { if (fn) fn(); } catch (e) {} }
  function close() { if (els) els.ov.classList.remove('mhv-verify-open'); document.documentElement.style.overflow = ''; }

  function showSendStep() {
    els.send.style.display = 'block'; els.send.textContent = 'Text me a code'; els.send.disabled = false;
    els.codeRow.style.display = 'none'; els.resend.style.display = 'none';
  }
  function showCodeStep(phoneMasked) {
    els.send.style.display = 'none';
    els.sub.textContent = 'Enter the 6-digit code we texted to ' + (phoneMasked || 'your phone') + '.';
    els.codeRow.style.display = 'flex';
    els.resend.style.display = 'block'; els.resend.textContent = 'Resend code';
    els.code.value = ''; els.code.focus();
  }
  function open(opts) {
    opts = opts || {}; ensureDom(); cb = opts.onVerified || null; showErr(''); els.code.value = '';
    els.sub.textContent = opts.message || 'To bid you must verify your phone. We’ll text a 6-digit code to the number on your account.';
    showSendStep();
    els.ov.classList.add('mhv-verify-open');
    document.documentElement.style.overflow = 'hidden';
    // If a code is already outstanding (e.g. texted at registration), jump straight to entry.
    window.mhvFetch(SERVER + '/verify/phone/status').then(function (r) { return r.json(); }).then(function (d) {
      if (!els.ov.classList.contains('mhv-verify-open')) return;
      if (d && d.verified) { onSuccess(); return; }
      if (d && d.codePending) showCodeStep(d.phoneMasked);
    }).catch(function () {});
  }

  // Returns a promise<boolean verified>. Opens the modal only if the account must verify.
  function ensureVerified(opts) {
    opts = opts || {};
    return window.mhvFetch(SERVER + '/verify/phone/status').then(function (r) { return r.json(); }).then(function (d) {
      if (d && d.verified) { if (opts.onVerified) opts.onVerified(); return true; }
      if (d && d.required) { open(opts); return false; }
      if (opts.onVerified) opts.onVerified(); return true; // grandfathered / unknown → allow
    }).catch(function () { if (opts.onVerified) opts.onVerified(); return true; });
  }

  var CSS =
    '#mhv-verify-overlay{position:fixed;inset:0;z-index:100000;display:none;align-items:center;justify-content:center;background:rgba(10,12,16,0.62);padding:16px;font-family:Arial,Helvetica,sans-serif;}' +
    '#mhv-verify-overlay.mhv-verify-open{display:flex;}' +
    '.mhv-verify-card{position:relative;width:100%;max-width:380px;background:#fff;border-radius:14px;padding:26px 24px 22px;text-align:center;box-shadow:0 12px 40px rgba(0,0,0,0.35);}' +
    '.mhv-verify-close{position:absolute;top:10px;right:14px;background:none;border:none;font-size:26px;line-height:1;color:#999;cursor:pointer;}' +
    '.mhv-verify-ico{font-size:34px;margin-bottom:6px;}' +
    '.mhv-verify-title{margin:0 0 8px;font-size:1.4rem;color:#12171D;}' +
    '.mhv-verify-sub{margin:0 0 16px;font-size:1rem;line-height:1.45;color:#4a4a4a;}' +
    '.mhv-verify-err{margin:0 0 12px;padding:9px 12px;border-radius:8px;background:rgba(145,62,62,0.1);color:#913e3e;font-size:0.92rem;}' +
    '.mhv-verify-btn{display:block;width:100%;padding:13px 16px;border:none;border-radius:9px;background:#2C5F63;color:#fff;font-size:1.05rem;font-weight:700;cursor:pointer;}' +
    '.mhv-verify-btn:disabled{opacity:0.6;cursor:default;}' +
    '.mhv-verify-code-row{display:flex;gap:8px;}' +
    '.mhv-verify-code-row input{flex:1;min-width:0;padding:12px;border:1px solid rgba(0,0,0,0.2);border-radius:9px;font-size:1.5rem;letter-spacing:0.3em;text-align:center;}' +
    '.mhv-verify-code-row .mhv-verify-btn{width:auto;flex:0 0 auto;padding:13px 20px;}' +
    '.mhv-verify-resend{margin-top:12px;background:none;border:none;color:#2C5F63;font-size:0.95rem;font-weight:600;cursor:pointer;text-decoration:underline;}';

  window.MHVVerify = { open: open, ensureVerified: ensureVerified };
})();
